exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fotos-modal-ver-detalle-cuadratura[data-v-315368b2] {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));\n  gap: 10px;\n  padding: 30px 10px;\n}\n.fotos-modal-ver-detalle-cuadratura figure img[data-v-315368b2] {\n  max-width: 100%;\n  height: auto;\n  -o-object-fit: fill;\n     object-fit: fill;\n  margin: 0 !important;\n}\n", ""]);

// exports
